module.exports = __webpack_public_path__ + "img/77400.ccdff769.jpg";